import { createSelector } from '@reduxjs/toolkit';
import { type RootState } from 'store';

export const getFiltersState = (state: RootState) => state.filters;

export const getFilters = createSelector(
  getFiltersState,
  (state) => state.filters,
);

export const getLeadsFilters = createSelector(
  getFilters,
  (state) => state.leads,
);

export const getLeadsSourceFilter = createSelector(
  getLeadsFilters,
  (state) => state.source,
);

export const getLeadsConvertedFilter = createSelector(
  getLeadsFilters,
  (state) => state.includeConverted,
);

export const getJobsFilters = createSelector(getFilters, (state) => state.jobs);

export const getJobsStatusFilter = createSelector(
  getJobsFilters,
  (state) => state.status,
);

export const getJobsFinanceStatusFilter = createSelector(
  getJobsFilters,
  (state) => state.financeStatus,
);

const filtersSelectors = {
  getFilters,
  getLeadsFilters,
  getLeadsSourceFilter,
  getLeadsConvertedFilter,
  getJobsFilters,
  getJobsStatusFilter,
  getJobsFinanceStatusFilter,
};

export default filtersSelectors;
